import { Vue, Component, Inject } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import type { IResourceModel } from '@/shared/model/briefing-widget.model';
import BriefingService from '@/service/briefing.service';

const briefingStore = namespace('briefingStore');
const appStoreState = namespace('appStore');
@Component({})
export default class PopupSubmitReportComponent extends Vue {
  language = localStorage.getItem('currentLanguage') !== undefined ? localStorage.getItem('currentLanguage') : 'en';
  userLogin = this.$store.getters?.userIdentity?.id || JSON.parse(localStorage.getItem('localStorageUser'))?.id;
  @appStoreState.Getter
  public getIsShowPopupSubmitReport!: boolean;

  @appStoreState.Mutation
  public setIsShowPopupSubmitReport!: (payload: boolean) => void;

  @appStoreState.Getter
  public getIsShowPopupSubmitReportSuccess!: boolean;

  @appStoreState.Mutation
  public setIsShowPopupSubmitReportSuccess!: (payload: boolean) => void;

  @briefingStore.Getter
  public getSelectedResource!: IResourceModel;

  @Inject('briefingService')
  private briefingService: () => BriefingService;

  isButtonVisible = false;
  targetStartTimestamp = 1731250801000;
  targetEndTimestamp = 1734188399000;
  targetTimestampTestStart = 1731057120000;
  targetTimestampTestEnd = 1731057150000;

  created() {
    this.checkButtonVisibility();
  }
  // mounted() {
  //   console.log('items mo', this.items)
  // }

  checkButtonVisibility() {
    const now = Date.now(); // Lấy thời gian hiện tại (milliseconds từ epoch)
    if (now >= this.targetStartTimestamp && now <= this.targetEndTimestamp) {
      this.isButtonVisible = true; // Hiển thị nút nếu nằm trong khoảng thời gian
    } else if (now < this.targetStartTimestamp) {
      const timeUntilVisible = this.targetStartTimestamp - now;
      setTimeout(() => {
        this.isButtonVisible = true;
        // Đặt thêm logic để ẩn nút khi hết khoảng thời gian
        const duration = this.targetEndTimestamp - this.targetStartTimestamp;
        setTimeout(() => {
          this.isButtonVisible = false; // Ẩn nút sau khoảng thời gian kết thúc
        }, duration);
      }, timeUntilVisible);
    }
  }

  // checkButtonVisibility() {
  //   const now = Date.now(); // Lấy thời gian hiện tại (milliseconds từ epoch)
  //   if (now >= this.targetTimestampTestStart && now <= this.targetTimestampTestEnd) {
  //     this.isButtonVisible = true; // Hiển thị nút nếu nằm trong khoảng thời gian
  //   } else if (now < this.targetTimestampTestStart) {
  //     const timeUntilVisible = this.targetTimestampTestStart - now;
  //     setTimeout(() => {
  //       this.isButtonVisible = true;
  //       // Đặt thêm logic để ẩn nút khi hết khoảng thời gian
  //       const duration = this.targetTimestampTestEnd - this.targetTimestampTestStart;
  //       setTimeout(() => {
  //         this.isButtonVisible = false; // Ẩn nút sau khoảng thời gian kết thúc
  //       }, duration);
  //     }, timeUntilVisible);
  //   }
  // }

  submitReport() {
    if (this.userLogin) {
      const userProfile = JSON.parse(localStorage.getItem('localStorageUser'));
      const payload = {
        userId: userProfile?.id,
        userName: userProfile.lastName,
        reportId: this.getSelectedResource.docId,
        reportTitle: this.getSelectedResource.title,
      };
      this.briefingService()
        .submitReport(payload)
        .then(res => {
          console.log('submit report success', res);
          if (res.data.statusCodeValue === 200) {
            this.setIsShowPopupSubmitReport(false);
            this.setIsShowPopupSubmitReportSuccess(true);
          }
        });
    }
  }

  handleCloseModal() {
    this.setIsShowPopupSubmitReport(false);
  }
}
